import { isPositiveNumber } from "../../utils/formValidation";
import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import Select from "../../components/ui/Select";
import React, { useState } from "react";
import { createExchangeRate } from "../../services/exchangeRate";
import { getApiErrorMessage } from "../../utils/apiError";
import "./AddFxRateModal.css";

interface ModalProps {
  onClose: () => void;
  onSuccess: () => void;
}

const AddFxRateModal: React.FC<ModalProps> = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    fromCurrency: "NGN",
    toCurrency: "GBP",
    buyRate: "",
    sellRate: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isPositiveNumber(formData.buyRate) || !isPositiveNumber(formData.sellRate)) {
      setError("Enter positive buy and sell rates.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await createExchangeRate({
        fromCurrency: formData.fromCurrency,
        toCurrency: formData.toCurrency,
        buyRate: Number(formData.buyRate),
        sellRate: Number(formData.sellRate),
      });
      onSuccess();
    } catch (err: unknown) {
      setError(getApiErrorMessage(err, "Failed to create new rate"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title={<>Add New FX Rate</>} onClose={onClose} size="medium">
<div className="fx-pricing-modal legacy-modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="modal-body">
          <form onSubmit={handleSave} className="create-form">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">From Currency</label>
                <Select
                  name="fromCurrency"
                  value={formData.fromCurrency}
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option value="NGN">Nigerian Naira (NGN)</option>
                  <option value="USD">US Dollar (USD)</option>
                  <option value="EUR">Euro (EUR)</option>
                  <option value="GBP">British Pound (GBP)</option>
                </Select>
              </div>

              <div className="form-group">
                <label className="form-label">To Currency</label>
                <Select
                  name="toCurrency"
                  value={formData.toCurrency}
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option value="GBP">British Pound (GBP)</option>
                  <option value="USD">US Dollar (USD)</option>
                  <option value="EUR">Euro (EUR)</option>
                  <option value="NGN">Nigerian Naira (NGN)</option>
                </Select>
              </div>

              <div className="form-group">
                <label className="form-label">Buy Rate</label>
                <input
                  type="number" min="0.000001"
                  name="buyRate"
                  value={formData.buyRate}
                  onChange={handleInputChange}
                  placeholder="1250.75"
                  step="0.01"
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Sell Rate</label>
                <input
                  type="number" min="0.000001"
                  name="sellRate"
                  value={formData.sellRate}
                  onChange={handleInputChange}
                  placeholder="1260.50"
                  step="0.01"
                  className="form-input"
                  required
                />
              </div>
            </div>
            {error && <p className="modal-error">{error}</p>}
            <div className="form-actions">
              <Button variant="primary" type="submit" className="submit-btn" disabled={loading}>
                {loading ? "Creating..." : "Create Rate"}
              </Button>
            </div>
          </form>
        </div>
      </div>
</Modal>
  );
};

export default AddFxRateModal;
